// glow: soft violet shadow around the icon box (off where it sits on a dark header)
export function CampusMeshLogo({ size = "md", className = "", lightText = false, glow = true }) {
    const config = {
        sm: { icon: 36, fontSize: 18, gap: 8 },
        md: { icon: 34, fontSize: 20, gap: 12 },
        lg: { icon: 72, fontSize: 36, gap: 16 },
        xl: { icon: 40, fontSize: 23, gap: 12 },
    }[size];

    return (
        <div
            className={className}
            style={{
                display: "inline-flex",
                alignItems: "center",
                gap: config.gap,
                userSelect: "none",
            }}
        >
            {/* ── Icon box ── */}
            <div
                style={{
                    width: config.icon,
                    height: config.icon,
                    borderRadius: config.icon * 0.22,

                    background: "#8f8dfc",
                    boxShadow: glow ? "0px 0px 15px 0px #8F8CFF80" : "none",


                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                    position: "relative",
                    overflow: "hidden",
                }}
            >
                {/* Subtle inner glow */}
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        // background: "radial-gradient(circle at 35% 35%, rgba(255,255,255,0.18) 0%, transparent 65%)",
                        borderRadius: "inherit",
                    }}
                />
                <img
                    src="/logo_campus_last.svg"
                    alt="CampusMesh icon"
                    width={config.icon * 0.72}
                    height={config.icon * 0.72}
                    style={{ position: "relative", zIndex: 1 }}
                />
            </div>

            {/* ── Wordmark ── */}
            <div
                className="d-none d-sm-flex"
                style={{
                    display: "flex",
                    alignItems: "baseline",
                    fontFamily: "'Inter','Segoe UI',sans-serif",
                    fontSize: config.fontSize,
                    fontWeight: 800,
                    letterSpacing: "-0.03em",
                    lineHeight: 1,
                }}
            >
                {/* <span style={{ color: "#ffffff" }}>Campus</span> */}
                <span style={{ color: lightText ? "#ffffff" : "#1e1b3a" }}>Campus</span>
                <span
                    style={{
                        color: "#8f8dfc",
                        textShadow: "0px 0px 15px 0px #8F8CFF80",
                    }}
                >
                    Mesh
                </span>
            </div>
        </div>
    );
}
